import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const downloadInvoice = async (folderId, echeanceNumber = 1) => {
  try {
    if (!folderId) {
      throw new Error('ID du dossier requis pour générer la facture');
    }

    const response = await axios.post(`${API_BASE_URL}/api/invoice/generate`, {
      folder_id: folderId,
      echeance_number: echeanceNumber
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
      },
      responseType: 'blob', // Important: la réponse est un objet binaire
    });

    // Créer un Blob à partir du flux PDF
    const file = new Blob(
      [response.data],
      { type: 'application/pdf' }
    );

    // Construire une URL à partir du fichier
    const fileURL = URL.createObjectURL(file);

    // Créer un lien et cliquer dessus pour déclencher le téléchargement
    const link = document.createElement('a');
    link.href = fileURL;
    const fileName = `facture-${folderId}-echeance-${echeanceNumber}.pdf`;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    // Nettoyage
    link.parentNode.removeChild(link);
    URL.revokeObjectURL(fileURL);

    return { success: true, fileName };

  } catch (error) {
    console.error("Erreur lors du téléchargement de la facture:", error);
    // Gérer la réponse d'erreur potentielle si elle est au format JSON
    if (error.response && error.response.data.type === 'application/json') {
      const reader = new FileReader();
      reader.onload = function () {
        const errorData = JSON.parse(this.result);
        console.error("Détails de l'erreur du serveur:", errorData);
      };
      reader.readAsText(error.response.data);
    }
    throw error;
  }
};

// services/invoice.service.js
export const getInvoiceStatsOpco = async (year, partnerId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/stats/invoice/opco`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
      },
      body: JSON.stringify({ year, partnerId })
    });

    // Gérer les erreurs HTTP
    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erreur lors de la récupération des statistiques OPCO:', error);
    throw error;
  }
};
